export enum ForderungspositionArt {
  STATIONAER = 'STATIONAER',
  AMBULANT = 'AMBULANT',
  PFLEGE = 'PFLEGE',
  LOHNERSATZ = 'LOHNERSATZ',
  THERAPIE = 'THERAPIE',
  FAHRTKOSTEN = 'FAHRTKOSTEN',
  HILFSMITTEL = 'HILFSMITTEL',
  MEDIKAMENT_UND_VERBAND = 'MEDIKAMENT_UND_VERBAND',
  GUTSCHRIFT = 'GUTSCHRIFT',
  DIVERSES = 'DIVERSES',
}
